import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setActiveStudent, setActiveSchool } from 'actions/user';
import { getUnreadNotifications } from 'actions/notifications';
import { Icon, ActionSheet, TooltipMenu } from '@haldor/ui';
import './_device.scss';
var DeviceHeader = /*#__PURE__*/function (_Component) {
  function DeviceHeader() {
    var _this;
    _classCallCheck(this, DeviceHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DeviceHeader, [].concat(args));
    _defineProperty(_this, "isIndex", function () {
      return window.location.pathname == '/';
    });
    _defineProperty(_this, "goBack", function (event) {
      event.preventDefault();
      _this.props.history.goBack();
    });
    _defineProperty(_this, "selectSchool", function () {
      var students = _this.props.students;
      var items = [];
      students.forEach(function (student) {
        var studentName = student !== null && student !== void 0 && student.firstName || student !== null && student !== void 0 && student.lastName ? "".concat((student === null || student === void 0 ? void 0 : student.firstName) || '', " ").concat((student === null || student === void 0 ? void 0 : student.lastName) || '').trim() : student === null || student === void 0 ? void 0 : student.email;
        if (student.id == _this.props.activeStudent.id) {
          studentName = /*#__PURE__*/React.createElement("span", {
            className: "badge-label",
            style: {
              fontWeight: "bold"
            }
          }, studentName, " ", /*#__PURE__*/React.createElement(Icon, {
            style: {
              marginLeft: "1rem"
            },
            name: "check"
          }), " ");
        } else {
          var haveUnreads = false;

          // Find out if user have unread conversations/posts/documentaions on current child/student
          if (_this.props.unreadNotifications != null && _this.props.unreadNotifications.notificationsPerStudent != null && _this.props.unreadNotifications.notificationsPerStudent.length > 0) {
            haveUnreads = _this.props.unreadNotifications.notificationsPerStudent.find(function (n) {
              return n.studentId === student.id && n.unreadMessages > 0;
            }) || false;
          }
          studentName = /*#__PURE__*/React.createElement("span", {
            className: "badge-label",
            style: {
              display: 'inline-flex',
              alignItems: 'center'
            }
          }, /*#__PURE__*/React.createElement("span", {
            style: {
              margin: "0 0.4rem 0 0"
            }
          }, studentName, " "), haveUnreads ? /*#__PURE__*/React.createElement("span", {
            className: "badge",
            style: {
              transform: 'none',
              borderRadius: '100%',
              position: 'static',
              width: '18px',
              height: '18px'
            }
          }) : null);
        }
        items.push({
          label: studentName,
          value: {
            student: student
          }
        });
      });
      ActionSheet.prompt({
        items: items
      }).then(function (selection) {
        _this["switch"](selection.student);
      }, function () {
        // This method only runs if user closes the prompt without pressing an option
        // This method is also optional
        console.log('prompt was closed');
      });
    });
    _defineProperty(_this, "switch", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(student) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return _this.props.setActiveStudent(student);
            case 1:
              _this.props.history.push("/switchschool");
              _this.props.getUnreadNotifications(_this.props.activeStudent.id);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "renderAction", function (action, index) {
      return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        key: index,
        onClick: action.onClick
      }, action.icon != null ? /*#__PURE__*/React.createElement(Icon, {
        name: action.icon
      }) : null, action.value);
    });
    return _this;
  }
  _inherits(DeviceHeader, _Component);
  return _createClass(DeviceHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var actionTrigger = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
        name: "Bullets"
      }));
      var notCurrentStudentHaveUnreads = false;
      if (this.props.students.length > 1) {
        if (this.props.unreadNotifications != null && this.props.unreadNotifications.notificationsPerStudent != null && this.props.unreadNotifications.notificationsPerStudent.length > 0) {
          notCurrentStudentHaveUnreads = this.props.unreadNotifications.notificationsPerStudent.find(function (n) {
            return n.studentId !== _this2.props.activeStudent.id && n.unreadMessages > 0;
          }) || false;
        }
      }
      var badge = notCurrentStudentHaveUnreads ? /*#__PURE__*/React.createElement("span", {
        className: "badge",
        style: {
          display: 'inline-flex',
          justifyContent: 'center',
          transform: 'none',
          borderRadius: '100%',
          position: 'static',
          margin: '0 0 0.2rem 0.4rem',
          width: '18px',
          height: '18px'
        }
      }) : null;
      var label = /*#__PURE__*/React.createElement("span", {
        className: "badge-label"
      }, this.props.activeStudent.firstName);
      return /*#__PURE__*/React.createElement("div", {
        className: "device-menu"
      }, /*#__PURE__*/React.createElement("div", {
        className: "left"
      }, /*#__PURE__*/React.createElement("div", {
        id: "page-title"
      }, this.props.title), /*#__PURE__*/React.createElement("div", {
        id: "menu-page-title"
      })), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, this.props.students.length > 1 ? /*#__PURE__*/React.createElement("div", {
        onClick: this.selectSchool
      }, label, /*#__PURE__*/React.createElement(Icon, {
        name: "Chevron"
      }), badge) : /*#__PURE__*/React.createElement("div", null, label)));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    title: state.Header.title,
    settings: state.Header,
    activeSchool: state.User.activeSchool,
    activeStudent: state.User.activeStudent,
    students: state.guardians.students,
    unreadNotifications: state.Notifications.unreadNotifications
  };
}
export default withRouter(connect(mapStateToProps, {
  setActiveSchool: setActiveSchool,
  setActiveStudent: setActiveStudent,
  getUnreadNotifications: getUnreadNotifications
})(DeviceHeader));